import { GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'TableOfContentsHeading',
    components: {
        GlLink
    },
    props: {
        heading: {
            type: Object,
            required: true
        }
    }
};
